import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=6f9480f4&scoped=true&"
import script from "./AddContact.vue?vue&type=script&lang=js&"
export * from "./AddContact.vue?vue&type=script&lang=js&"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=6f9480f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9480f4",
  null
  
)

export default component.exports